import { Component, OnInit } from "@angular/core";

import { BrowserTitleService } from "../../../common/browser-title/browser-title.service";
import { SdpIcon } from "../../../common/icon/models";
import { GatewayDownloadFile } from "../models";
import { GatewaysService } from "../gateways.service";

interface NamedGatewayDownloadFile extends GatewayDownloadFile {
	name?: string;
}

@Component({
	templateUrl: "./gateway-download.component.html"
})
export class GatewayDownloadComponent implements OnInit {

	public downloadIcon: SdpIcon.Icon = { type: "fa", name: "download", cssClass: "sdp-download-icon" };
	public file!: NamedGatewayDownloadFile;
	public hasError = false;
	public supportEmail = "support@impulse.com";
	public changeLogUrl = "https://impulsepoint.atlassian.net/wiki/spaces/CMKB/pages/177897478/SafeConnect+SDP+Adminstration+Portal";

	constructor(
		private titleService: BrowserTitleService,
		private service: GatewaysService
	) { }

	public async ngOnInit() {
		this.titleService.setTitle("gateway.download.title");
		this.file = await this.service.getAvailableVersion();
		this.file.name = "SDP Gateway";
	}
}
